import React from "react";
import Lottie from "react-lottie";
import animdata from "./lotties/wave.json";
import { useRef, useEffect } from 'react';

export default function LoadingPage() {
  const animoptions = {
    loop: true,
    autoplay: true,
    animationData: animdata,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#000000",
        gap: "0.1rem",
        padding: "1rem",
      }}
    >
     
      {/* Slower Animation */}
      <div
        className="loading-animation"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src="./pulse-logo.png"
          alt="Pulse Logo"
          style={{
            position: "absolute",
            width: "200px",
            height: "auto",
            borderRadius: "30px",
            zIndex: 10,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            animation:
              "stylishFadeIn 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards",
            opacity: 0,
          }}
        />

        <Lottie
          options={animoptions}
          speed={0.4}
          style={{
            maxWidth: "90vw",
            position: "relative",
            zIndex: 1,
          }}
        />
        <style jsx>{`
          @keyframes stylishFadeIn {
            0% {
              opacity: 0;
              transform: translate(-50%, -50%) scale(0.7);
              filter: blur(10px);
            }
            70% {
              filter: blur(5px);
            }
            100% {
              opacity: 1;
              transform: translate(-50%, -50%) scale(1);
              filter: blur(0);
            }
          }
        `}</style>
      </div>
      <p
        style={{
          fontFamily: "'Amazon Ember', Arial, sans-serif",
          color: "#888888",
          fontSize: "3rem",
          margin: 0,
          textAlign: "center",
          fontWeight: "300",
          letterSpacing: "0.5px",
        }}
      >
        Powered by{" "}
        <strong
          style={{
            color: "#aaaaaa",
            fontWeight: "600",
            fontFamily: "'Amazon Ember', Arial, sans-serif",
          }}
        >
          SWOTS CIA
        </strong>
      </p>
      <p
        style={{
          fontFamily: "'Amazon Ember', Arial, sans-serif",
          color: "#888888",
          fontSize: "1.5rem",
          margin: 0,
          textAlign: "center",
          fontWeight: "300",
        }}
      >
        Contact Us:{" "}
        <strong style={{ color: "#aaaaaa" }}>swots-cia@amazon.com </strong>
      </p>
       <EmberAnimation/>
    </div>
  );
}



function EmberAnimation() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let embers = [];
    let animationId = null;

    // More precise resize function
    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    // Ember class
    class Ember {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = canvas.height + Math.random() * 100;
        this.vx = (Math.random() - 0.5) * 0.3;
        this.vy = Math.random() * 0.6 + 0.4;
        this.size = Math.random() * 2 + 0.8;
        this.life = Math.random() * 200 + 150;
        this.opacity = Math.random() * 0.6 + 0.3;
        this.color = Math.random() < 0.5 ? [255, 120, 60] : [255, 180, 90];
      }

      update() {
        this.x += this.vx;
        this.y -= this.vy;
        this.life--;
        this.opacity *= 0.995;
      }

      draw(ctx) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${this.color[0]},${this.color[1]},${this.color[2]},${this.opacity})`;
        ctx.shadowBlur = 8;
        ctx.shadowColor = "rgba(255,140,60,.6)";
        ctx.fill();
      }
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Cap at 500 embers instead of 2000 for better performance
      if (embers.length < 500 && Math.random() < 0.9) embers.push(new Ember());
      
      // Filter instead of splice-while-iterating (fixes the memory leak)
      embers = embers.filter((e) => {
        e.update();
        e.draw(ctx);
        return e.life > 0 && e.y > 0;
      });

      animationId = requestAnimationFrame(animate);
    };

    // Initial setup
    resize();
    window.addEventListener('resize', resize);
    animate();

    // Cleanup — cancel the animation frame to prevent background leak
    return () => {
      window.removeEventListener('resize', resize);
      if (animationId) cancelAnimationFrame(animationId);
      embers = [];
    };
  }, []);

   return (
    <canvas 
      ref={canvasRef} 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        backgroundColor: 'transparent'
      }} 
    />
  );
}